var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageDynamique(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(-140 -4453)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(140 4453)",
    fill: "rgba(30,194,138,0.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "appreciation",
    transform: "translate(164.46 4481.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M48.939,1h-.8A21.266,21.266,0,0,0,35.542,5.165,21.22,21.22,0,0,0,22.944,1h-.8A21.141,21.141,0,0,0,8.028,37.882l11.135,9.983L11.142,61.439l10.333-1.292,3.877,9.048,6.095-10.316,1.4,1.258a4.025,4.025,0,0,0,5.376,0l1.4-1.258L45.726,69.2,49.6,60.148,59.936,61.44,51.915,47.866,63.05,37.883A21.141,21.141,0,0,0,48.939,1ZM3.555,25.512H18.827v15.6h-3.86L9.516,36.223A18.919,18.919,0,0,1,3.555,25.512Zm23.071,0a1.116,1.116,0,0,1,1.114,1.114V40a1.116,1.116,0,0,1-1.114,1.114H25.512v-15.6Zm-3.343,15.6H21.055v-15.6h2.228Zm-2.429,8.272,3.676,3.3L21.483,57.9l-6.115.764Zm4.816,14.9-2.256-5.263L26.225,54.2l3.532,3.167Zm19.739,0-4.087-6.916L44.854,54.2l2.811,4.818Zm10.3-5.613L49.6,57.9l-3.047-5.223,3.676-3.3Zm5.854-22.442L36.74,58.479a1.844,1.844,0,0,1-2.4,0L17.453,43.339h9.173a3.338,3.338,0,0,0,3.138-2.228H30.9l2.141.714a7.8,7.8,0,0,0,2.467.4H47.8a3.347,3.347,0,0,0,3.343-3.343,3.306,3.306,0,0,0-.447-1.639,3.293,3.293,0,0,0,1.114-4.457A3.293,3.293,0,0,0,52.92,28.33a3.336,3.336,0,0,0-1.782-6.16H45.567a1.116,1.116,0,0,1-1.114-1.114v-7.8A4.461,4.461,0,0,0,40,8.8a2.231,2.231,0,0,0-2.228,2.228v6.011a8.423,8.423,0,0,1-8.015,8.44,3.337,3.337,0,0,0-3.126-2.195H3.29c-.023-.381-.061-.76-.061-1.143A18.934,18.934,0,0,1,22.141,3.228h.8A18.981,18.981,0,0,1,34.759,7.373l.781.622.694-.553.087-.07A18.986,18.986,0,0,1,48.136,3.228h.8A18.913,18.913,0,0,1,61.564,36.223Zm-31.6-8.531A10.633,10.633,0,0,0,40,17.039V11.028a2.231,2.231,0,0,1,2.228,2.228v7.8A3.347,3.347,0,0,0,45.567,24.4h5.571a1.114,1.114,0,0,1,0,2.228H46.682v2.228h3.343a1.114,1.114,0,0,1,0,2.228H46.682v2.228H48.91a1.114,1.114,0,1,1,0,2.228H46.682v2.228H47.8A1.114,1.114,0,1,1,47.8,40H35.511a5.547,5.547,0,0,1-1.763-.286l-2.485-.828H29.969Z",
    transform: "translate(0)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M7.035,13.294l1.924,1.124a14.526,14.526,0,0,1,12.492-7.19V5A16.762,16.762,0,0,0,7.035,13.294Z",
    transform: "translate(0.689 0.457)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M5.341,17.034l2.177.475a14.474,14.474,0,0,1,.623-2.085l-2.08-.8A16.684,16.684,0,0,0,5.341,17.034Z",
    transform: "translate(0.496 1.556)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M57.015,19.974a14.48,14.48,0,0,1-.148,2.061l2.2.32a16.661,16.661,0,0,0,.172-2.381Z",
    transform: "translate(6.379 2.167)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M53.817,28.655,55.5,30.118a16.629,16.629,0,0,0,1.433-1.909L55.057,27A14.463,14.463,0,0,1,53.817,28.655Z",
    transform: "translate(6.031 2.969)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M55.821,25.573l2.026.929a16.732,16.732,0,0,0,.836-2.235l-2.138-.628a14.417,14.417,0,0,1-.723,1.934Z",
    transform: "translate(6.26 2.585)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M27,45h2.228v2.228H27Z",
    transform: "translate(2.969 5.024)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M35,45h2.228v2.228H35Z",
    transform: "translate(3.882 5.024)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M31,45h2.228v2.228H31Z",
    transform: "translate(3.426 5.024)",
    fill: "#58a596"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDynamique);
export default __webpack_public_path__ + "static/media/image-dynamique.eb34f1d998689ffde76b9dc4ec97dfcc.svg";
export { ForwardRef as ReactComponent };